import { Sentry } from '@/integrations/sentry';

type SentryRouterType = Parameters<
  typeof Sentry.tanstackRouterBrowserTracingIntegration
>[0];

/**
 * Add TanStack Router integration for navigation tracing.
 * Must be called after router is created.
 */
export function addRouterIntegration(router: SentryRouterType) {
  const client = Sentry.getClient();
  if (!client) {
    // Sentry not initialized (no DSN configured)
    return;
  }

  try {
    client.addIntegration(
      Sentry.tanstackRouterBrowserTracingIntegration(router),
    );
    // eslint-disable-next-line no-console
    console.info('[Sentry] TanStack Router integration added');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[Sentry] Failed to add router integration:', error);
  }
}
